export default __webpack_public_path__ + "static/media/87c2f9656be6d6170b57da9c95351db91581604404199.6bc33cf6.webp";